<template>
  <!-- Page Content -->
  <div class="h-100 d-flex flex-column">
    <div class="row f-row justify-content-center no_nav_height">
      <!-- First Column -->
      <transition name="fadeCharts" v-if="!hideLeft">
        <div
          class="col text-center"
          v-bind:class="[expandLeft ? 'col-12' : '', 'col-8']"
        >
          <div class="h-100 d-flex flex-column">
            <!-- 2 Charts Column -->
            <div class="row f-row no_nav_height">
              <div class="col col-12" style="height:100%; width:100%">
                <!-- Chart 1 -->
                <div class="h-50 d-flex flex-column" style="width: 100%;">
                  <!-- Row: title -->
                  <div class="row f-row markets-chart-title">
                    <!-- <div class=" col col-12">
                      HISTORY (HOVER OVER CHART TO VISUALIZE PATTERNS)
                    </div> -->
                    <slot name="spot"></slot>
                  </div>
                  <!-- Row: Chart -->
                  <div class="row f-row h-100">
                    <div
                      class="col col-12 text-center progress-div"
                      style="top: 22.5%!important;"
                      v-if="showLoading"
                    >
                      <v-progress-circular
                        indeterminate
                        :width="3"
                        color="primary"
                      ></v-progress-circular>
                    </div>
                    <div
                      class="col col-12 text-center"
                      v-else-if="chartData.length === 0"
                      style="position: absolute; left: 0; top: 27.5%; z-index: 10000000;"
                    >
                      No Data Available
                    </div>
                    <div class="col col-12" style="height:100%; width:100%">
                      <div
                        class="h-100 d-flex flex-column"
                        id="pattern_hist-div"
                        style="width: 100%;"
                      >
                        <svg id="svg-pattern_hist"></svg>
                      </div>
                    </div>
                  </div>
                  <!-- Row: legend -->
                  <div
                    class="row f-row"
                    style="position: absolute; left: 0; top: 5vh; z-index: 0;"
                  >
                    <div class="col col-1"></div>
                    <div class="col col-8 text-left">
                      <table
                        class="table table-sm table-responsive table-borderless table-market-legend"
                        style="width: 100%; background: rgba(0,0,0,0)"
                      >
                        <tbody>
                          <tr>
                            <td class="text-center" style="width:10%;">
                              <div class="triangle-topleft"></div>
                              <span class="inline-ul ml-1">UP/DOWN</span>
                            </td>
                            <td class="text-center showNet" style="width:10%;">
                              <i class="fa fa-minus"></i>
                              <span
                                class="inline-ul ml-1"
                                style="color: var(--textinactive)"
                                >MA (20, close)
                              </span>
                            </td>
                            <td class="text-center showRed" style="width:10%;">
                              <i class="fa fa-minus"></i>
                              <span
                                class="inline-ul ml-1"
                                style="color: var(--textinactive)"
                                >MA (40, close)
                              </span>
                            </td>
                            <td
                              class="text-center showExposure"
                              style="width:10%;"
                            >
                              <i class="fa fa-minus"></i>
                              <span
                                class="inline-ul ml-1"
                                style="color: var(--textinactive)"
                                >BOLLINGER</span
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!-- Chart 2 -->
                <div class="h-50 d-flex flex-column" style="width: 100%;">
                  <!-- Row: title -->
                  <div class="row f-row">
                    <div
                      class="markets-chart-title markets-chart-border"
                      style="width: 46.5%!important;"
                    >
                      ANALYZED PATTERN (LAST 20 DAYS)
                    </div>
                    <div
                      class="markets-chart-title markets-chart-border"
                      style="width: 53.5%!important;"
                    >
                      PATTERN {{ selectedPattern }} (20-DAY PATTERN AND NEXT 5
                      DAYS)
                    </div>
                  </div>
                  <!-- Row: Chart -->
                  <div class="row f-row h-100">
                    <div class="h-100" style="width: 46.5%!important;">
                      <div
                        class="h-100 d-flex flex-column"
                        id="analyzed_pattern-div"
                        style="width: 100%;"
                      >
                        <svg id="svg-analyzed_pattern"></svg>
                      </div>
                    </div>
                    <div class="h-100" style="width: 53.5%!important;">
                      <div
                        class="h-100 d-flex flex-column"
                        id="selected_pattern-div"
                        style="width: 100%;"
                      >
                        <svg id="svg-selected_pattern"></svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <!-- Second Column -->
      <transition name="fadeCharts" v-if="!hideRight">
        <div
          class="col text-center results-divider"
          v-bind:class="[expandRight ? 'col-12' : '', 'col-4']"
        >
          <div class="h-100 d-flex flex-column">
            <!-- 2 Charts Column -->
            <div class="row f-row no_nav_height">
              <div class="col col-12" style="height:100%; width:100%">
                <!-- Chart 1 -->
                <div class="h-50 d-flex flex-column" style="width: 100%;">
                  <!-- Row: title -->
                  <div class="row f-row">
                    <div class="markets-chart-title col col-12">
                      PATTERN RECOGNITION RESULTS
                    </div>
                  </div>
                  <!-- Row: Table -->
                  <div class="row f-row h-100 align-items-center">
                    <div class="col col-1"></div>
                    <div class="col col-10">
                      <table
                        class="table table-sm table-borderless table-market-legend"
                        style="width: 100%; background: rgba(0,0,0,0)"
                      >
                        <tbody>
                          <tr class="bdr-t">
                            <td class="text-left" colspan="3">
                              ANALYZED PATTERNS:
                            </td>
                          </tr>
                          <tr class="bdr-b">
                            <td
                              class="text-right"
                              colspan="2"
                              style="font-size: 1.2rem; color: var(--textactive);"
                            >
                              {{ nTotalPatterns }}
                            </td>
                            <td></td>
                          </tr>
                          <tr>
                            <td class="text-left" colspan="3">
                              SIMILAR PATTERNS:
                            </td>
                          </tr>
                          <tr class="bdr-b">
                            <td
                              class="text-right"
                              colspan="2"
                              style="font-size: 1.2rem; color: var(--textactive);"
                            >
                              {{ nSimilarPatterns }}
                            </td>
                            <td class="text-left">
                              <span
                                style="font-size: 0.8rem; color: var(--textactive);"
                              >
                                ({{
                                  (nSimilarPatterns / nTotalPatterns)
                                    | percentageFormat
                                }})
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left" colspan="3">
                              BULLISH PATTERNS:
                            </td>
                          </tr>
                          <tr class="bdr-b">
                            <td
                              class="text-right"
                              colspan="2"
                              style="color: var(--symmetry); font-size: 1.2rem;"
                            >
                              {{
                                (nBullishPatterns / nSimilarPatterns)
                                  | percentageFormat
                              }}
                            </td>
                            <td class="text-left">
                              <span
                                style="color: var(--symmetry); font-size: 0.8rem"
                              >
                                (AVE: +{{ aveBullishMove | priceFormat }})
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left" colspan="3">
                              BEARISH PATTERNS:
                            </td>
                          </tr>
                          <tr class="bdr-b">
                            <td
                              class="text-right"
                              colspan="2"
                              style="color: var(--red); font-size: 1.2rem;"
                            >
                              {{
                                (nBearishPatterns / nSimilarPatterns)
                                  | percentageFormat
                              }}
                            </td>
                            <td class="text-left">
                              <span
                                style="color: var(--red); font-size: 0.8rem;"
                              >
                                (AVE: {{ aveBearishMove | priceFormat }})
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- Chart 2 -->
                <div class="h-50 d-flex flex-column" style="width: 100%;">
                  <!-- Row: title -->
                  <div class="row f-row">
                    <div class="markets-chart-title col col-12">
                      SELECTED PATTERNS VS ALL HISTORY
                    </div>
                  </div>
                  <!-- Row: Chart -->
                  <div class="row f-row h-100">
                    <div class="col col-12" style="height:100%; width:100%">
                      <div
                        class="h-100 d-flex flex-column"
                        id="bars_pattern-div"
                        style="width: 100%;"
                      >
                        <svg id="svg-bars_pattern"></svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import {
  candleAlpha,
  colorExpo,
  colorExpoAlpha,
  colorHedge,
  colorHedgeAlpha,
  colorNet,
  colorRed,
  colorSelection,
  colorSelectionAlpha,
  currencyFormat,
  darkBackgroundAlpha,
  dateFormat,
  dnCandles,
  formatPercent,
  textactive,
} from "@/_core/_helpers/_parametric_tools";
import { D3Chart } from "@/_core/charts/D3Chart";
import { D3HoverPatterns } from "@/_core/charts/D3ChartHoverEffects";
import { axisBottom, format, max, scaleBand, scaleLinear, select } from "d3";

export default {
  name: "PatternRecognition",
  props: {
    chartDataRaw: { required: true, default: () => [] },
    colorTheme: { required: true, type: Boolean, default: true },
    showLoading: { required: true },

    // ============ Data Classes ===============
    processData: { required: true },
    dataReady: { required: true },
  },
  data() {
    return {
      // ========== Data =============
      aveBearishMove: 0,
      aveBullishMove: 0,
      chartData: [],
      chartDataSelected: [],
      clusterData: [],
      colorSelection: colorSelection,
      colorSelectionAlpha: colorSelectionAlpha,
      colorSelectionAlphaRaw: colorSelectionAlpha,
      colorSelectionRaw: colorSelection,
      currencyFormat: currencyFormat,
      currentCluster: 0,
      D3BarChart: null,
      D3ChartAnalyzed: null,
      D3ChartHistorical: null,
      D3ChartSelected: null,
      D3HoverPatterns: null,
      D3HoverPatternsBars: null,
      dateFormat: dateFormat,
      expandLeft: false,
      expandRight: false,
      formatPercent: formatPercent,
      hideLeft: false,
      hideRight: false,
      idxPatterns: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      nBearishPatterns: 0,
      nBullishPatterns: 0,
      nSimilarPatterns: 0,
      nTotalPatterns: 0,
      patternLength: 20,
      percentiles: [0, 0, 0, 0, 0],
      selectedPattern: 1,
      signalAll: [0, 0, 0, 0, 0],
      signalPattern: [0, 0, 0, 0, 0],
      svgNode: null,
      svgNodeHist: null,
      svgNodePATT: null,
      svgNodePATT2: null,
      yLength: 5,
    };
  },
  created() {
    this.D3ChartHistorical = new D3Chart(
      "pattern_hist-div",
      "svg-pattern_hist",
    );
    this.D3ChartAnalyzed = new D3Chart(
      "analyzed_pattern-div",
      "svg-analyzed_pattern",
    );
    this.D3ChartSelected = new D3Chart(
      "selected_pattern-div",
      "svg-selected_pattern",
    );
    this.D3BarChart = new D3Chart("bars_pattern-div", "svg-bars_pattern");
    this.D3HoverPatterns = new D3HoverPatterns();
  },
  mounted() {
    if (this.chartDataRaw.length > 0) {
      this.dataPrep();
    }

    let _this = this;
    window.addEventListener("resize", function() {
      _this.callWidth();
    });
  },
  filters: {
    priceFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",.4r")(val);
    },
    percentageFormat: function(val) {
      return format(",.1%")(val);
    },
  },
  watch: {
    colorTheme() {
      this.callWidth();
    },
    dataReady() {
      this.selectedPattern = 1;
      this.dataPrep();
    },
    showLoading() {
      if (this.showLoading) {
        this.nTotalPatterns = 0;
        this.nSimilarPatterns = 0;
        this.nBullishPatterns = 0;
        this.nBearishPatterns = 0;
        this.aveBullishMove = 0;
        this.aveBearishMove = 0;
        select("#pattern_hist-div")
          .select("svg > *")
          .remove();
        select("#analyzed_pattern-div")
          .select("svg > *")
          .remove();
        select("#selected_pattern-div")
          .select("svg > *")
          .remove();
        select("#bars_pattern-div")
          .select("svg > *")
          .remove();
      }
    },
  },
  methods: {
    createSelectedPatternData() {
      let init =
        this.idxPatterns[this.selectedPattern - 1].id - this.patternLength + 1;
      let end =
        this.idxPatterns[this.selectedPattern - 1].id + this.yLength + 1;
      this.chartDataSelected = this.chartData.slice(init, end);
    },
    getPercentiles(sortedAll) {
      let percentiles = [0, 0, 0, 0, 0];
      let med =
        sortedAll.reduce((total, x) => (x <= 0 ? total + 1 : total), 0) /
        sortedAll.length;
      let low_perc = med / 6;
      let high_perc = (1 - med) / 6;
      percentiles[0] = this.processData.percentile(sortedAll, 2 * low_perc);
      percentiles[1] = this.processData.percentile(sortedAll, 4 * low_perc);
      percentiles[2] = this.processData.percentile(sortedAll, med);
      percentiles[3] = this.processData.percentile(
        sortedAll,
        med + 2 * high_perc,
      );
      percentiles[4] = this.processData.percentile(
        sortedAll,
        med + 4 * high_perc,
      );
      return percentiles;
    },
    countHistogram(sorted, percentiles) {
      let signal = [0, 0, 0, 0, 0, 0];
      signal[0] = sorted.reduce(
        (total, x) => (x <= percentiles[0] ? total + 1 : total),
        0,
      );
      signal[1] = sorted.reduce(
        (total, x) =>
          x <= percentiles[1] && x > percentiles[0] ? total + 1 : total,
        0,
      );
      signal[2] = sorted.reduce(
        (total, x) =>
          x <= percentiles[2] && x > percentiles[1] ? total + 1 : total,
        0,
      );
      signal[3] = sorted.reduce(
        (total, x) =>
          x <= percentiles[3] && x > percentiles[2] ? total + 1 : total,
        0,
      );
      signal[4] = sorted.reduce(
        (total, x) =>
          x <= percentiles[4] && x > percentiles[3] ? total + 1 : total,
        0,
      );
      signal[5] = sorted.reduce(
        (total, x) => (x > percentiles[4] ? total + 1 : total),
        0,
      );
      return signal;
    },
    dataPrep() {
      let vis = this;
      this.chartData = this.chartDataRaw.slice(0, -1);
      let spot = this.chartData[this.chartData.length - 1].close;
      this.currentCluster = this.chartData[this.chartData.length - 1].cluster;

      this.clusterData = this.chartData
        .filter(
          (d) =>
            d.cluster === vis.currentCluster && Number.isFinite(d.y_pattern),
        )
        .map((d) => d.y_pattern);
      let sortedAll = JSON.parse(
        JSON.stringify(this.chartData.map((d) => d.y_pattern)),
      ).sort(function(a, b) {
        return a - b;
      });

      this.clusterData.sort(function(a, b) {
        return a - b;
      });
      this.percentiles = this.getPercentiles(sortedAll);
      this.signalPattern = this.countHistogram(
        this.clusterData,
        this.percentiles,
      );
      this.signalAll = this.countHistogram(sortedAll, this.percentiles);
      this.nSimilarPatterns = this.clusterData.reduce(
        (total, x) => (isFinite(x) ? total + 1 : total),
        0,
      );
      this.nTotalPatterns = sortedAll.reduce(
        (total, x) => (isFinite(x) ? total + 1 : total),
        0,
      );
      let positive = this.clusterData.filter((d) => d >= 0);
      let negative = this.clusterData.filter((d) => d < 0);
      this.nBullishPatterns = positive.length;
      this.nBearishPatterns = negative.length;
      this.aveBullishMove = spot * this.processData.average(positive);
      this.aveBearishMove = spot * this.processData.average(negative);
      this.percentiles = this.percentiles.map((d) => d * spot);

      let selected = this.chartData.map((d) => d.pattern_selected);
      let id;
      for (let i = 0; i < vis.idxPatterns.length; i++) {
        id = selected.indexOf(i + 1);
        vis.idxPatterns[i] = {
          id: id,
          date: vis.chartData[id - Math.round(vis.patternLength)].date,
          y: vis.chartData[id].low,
          text: (i + 1).toString(),
        };
      }
      let idxSorted = JSON.parse(JSON.stringify(this.idxPatterns))
        .map((d) => d.id)
        .sort(function(a, b) {
          return a - b;
        });
      let j = 0;
      for (let i = 0; i < vis.chartData.length; i++) {
        while (i > idxSorted[j] && j < idxSorted.length) {
          j++;
        }
        if (idxSorted[j] - i + 1 <= vis.patternLength) {
          vis.chartData[i]["highlight"] =
            vis.chartData[idxSorted[j]].pattern_selected;
        } else {
          vis.chartData[i]["highlight"] = 0;
        }
      }

      this.signalPattern = this.signalPattern.map(
        (d) => d / vis.nSimilarPatterns,
      );
      this.signalAll = this.signalAll.map((d) => d / vis.nTotalPatterns);

      this.createSelectedPatternData();

      this.createHistoricalChart(
        this.D3ChartHistorical,
        this.chartData,
        "PATTHIST",
        true,
        "svgNodeHist",
      );

      this.createHistoricalChart(
        this.D3ChartAnalyzed,
        this.processData.toSlice(this.chartData, this.patternLength),
        "PATT1",
        false,
        "svgNodePATT",
      );
      this.createSelectedPatternChart(
        this.D3ChartSelected,
        this.chartDataSelected,
        false,
      );
      this.createBarChart();
    },
    createBarChart() {
      // === set SVG canvas
      this.svgNode = this.D3BarChart.setSVG(
        0.5,
        80,
        0.05,
        50,
        0.5,
        27,
        0.05,
        50,
        this.colorTheme,
      );
      let max1 = max(this.signalAll, function(d) {
        return Number.isFinite(d) ? d : Infinity;
      });
      let max2 = max(this.signalPattern, function(d) {
        return Number.isFinite(d) ? d : Infinity;
      });
      let minMaxYAxis = [0, Math.max(max1, max2)];

      let barData = [
        {
          id: 0,
          date: "Strong Sell",
          all: this.signalAll[0],
          pattern: this.signalPattern[0],
          y: this.svgNode.height,
          text: this.formatPercent(this.signalPattern[0]),
        },
        {
          id: 1,
          date: "Sell",
          all: this.signalAll[1],
          pattern: this.signalPattern[1],
          y: this.svgNode.height,
          text: this.formatPercent(this.signalPattern[1]),
        },
        {
          id: 2,
          date: "Weak Sell",
          all: this.signalAll[2],
          pattern: this.signalPattern[2],
          y: this.svgNode.height,
          text: this.formatPercent(this.signalPattern[2]),
        },
        {
          id: 3,
          date: "Weak Buy",
          all: this.signalAll[3],
          pattern: this.signalPattern[3],
          y: this.svgNode.height,
          text: this.formatPercent(this.signalPattern[3]),
        },
        {
          id: 4,
          date: "Buy",
          all: this.signalAll[4],
          pattern: this.signalPattern[4],
          y: this.svgNode.height,
          text: this.formatPercent(this.signalPattern[4]),
        },
        {
          id: 5,
          date: "Strong Buy",
          all: this.signalAll[5],
          pattern: this.signalPattern[5],
          y: this.svgNode.height,
          text: this.formatPercent(this.signalPattern[5]),
        },
      ];

      this.colorSelection = this.colorSelectionRaw
        .slice(0, 3)
        .concat(this.colorSelectionRaw.slice(2, 6));
      this.colorSelectionAlpha = this.colorSelectionAlphaRaw
        .slice(0, 3)
        .concat(this.colorSelectionAlphaRaw.slice(2, 6));
      this.svgNode.x = scaleBand()
        .range([0, this.svgNode.width])
        .domain(
          barData.map(function(d) {
            return d.date;
          }),
        );
      this.svgNode.y = scaleLinear()
        .range([this.svgNode.height, 0])
        .domain([minMaxYAxis[0], minMaxYAxis[1]])
        .nice();
      // === set axis
      this.svgNode
        .append("g")
        .attr("class", "axis axis--x")
        .attr("transform", "translate(0," + this.svgNode.height + ")")
        .call(axisBottom(this.svgNode.x));
      this.D3HoverPatterns.hoverFctPatternBars(
        this.svgNode,
        barData,
        candleAlpha(this.colorTheme),
        "PATT",
        this.colorSelection,
        this.colorSelectionAlpha,
        "date",
        "pattern",
        true,
        true,
        true,
        [],
        this.formatPercent,
      );
      this.D3BarChart.bars(
        this.svgNode,
        barData,
        0.9,
        "REF",
        dnCandles(this.colorTheme),
        darkBackgroundAlpha(this.colorTheme),
        "date",
        "all",
        true,
        false,
        2,
      );
      this.D3BarChart.text(
        this.svgNode,
        barData,
        "date",
        "y",
        "text",
        "PATT",
        "0.65rem",
        0,
        0,
        "middle",
        "ideographic",
        0,
        textactive(this.colorTheme),
      );
    },
    createSelectedPatternChart(chartCanvas, data, showHighlight) {
      this.setSVGAndAxis(chartCanvas, data, "svgNodePATT2");
      // === vertical line
      this.svgNodePATT2
        .append("line")
        .attr("stroke-width", 1)
        .attr("stroke-opacity", 0.25)
        .attr("stroke", dnCandles(this.colorTheme))
        .attr(
          "x1",
          this.svgNodePATT2.x(data[this.patternLength].date) -
            this.svgNodePATT2.x.bandwidth() / 2,
        )
        .attr("y1", 0)
        .attr(
          "x2",
          this.svgNodePATT2.x(data[this.patternLength].date) -
            this.svgNodePATT2.x.bandwidth() / 2,
        )
        .attr("y2", this.svgNodePATT2.height);
      this.paintChartElements(
        chartCanvas,
        data.slice(-this.yLength - 1),
        "PATT2b",
        showHighlight,
        colorHedge(this.colorTheme),
        colorHedgeAlpha(this.colorTheme),
        colorHedge(this.colorTheme),
        colorNet(this.colorTheme),
        colorRed(this.colorTheme),
        "svgNodePATT2",
      );
      this.paintChartElements(
        chartCanvas,
        data.slice(0, this.patternLength),
        "PATT2a",
        showHighlight,
        colorExpo(this.colorTheme),
        colorExpoAlpha(this.colorTheme),
        colorExpo(this.colorTheme),
        colorNet(this.colorTheme),
        colorRed(this.colorTheme),
        "svgNodePATT2",
      );
    },
    createHistoricalChart(chartCanvas, data, name, showHighlight, svgField) {
      this.setSVGAndAxis(chartCanvas, data, svgField);
      if (showHighlight === false) {
        this[svgField]
          .append("line")
          .attr("stroke-width", 1)
          .attr("stroke-opacity", 0.25)
          .attr("stroke", dnCandles(this.colorTheme))
          .attr(
            "x1",
            this[svgField].x(data[data.length - 1].date) +
              this[svgField].x.bandwidth() / 2,
          )
          .attr("y1", 0)
          .attr(
            "x2",
            this[svgField].x(data[data.length - 1].date) +
              this[svgField].x.bandwidth() / 2,
          )
          .attr("y2", this[svgField].height);
      }
      this.paintChartElements(
        chartCanvas,
        data,
        name,
        showHighlight,
        colorExpo(this.colorTheme),
        colorExpoAlpha(this.colorTheme),
        colorExpo(this.colorTheme),
        colorNet(this.colorTheme),
        colorRed(this.colorTheme),
        svgField,
      );
    },
    setSVGAndAxis(chartCanvas, data, svgField) {
      // === set SVG canvas
      this[svgField] = chartCanvas.setSVG(
        0.025,
        50,
        0.025,
        50,
        0.5,
        27,
        0.5,
        47,
        this.colorTheme,
      );
      let minMaxYAxis = this.processData.minMax(data, "high", "low");
      minMaxYAxis = this.processData.minMax(data, "ma20", "ma20", minMaxYAxis);
      minMaxYAxis = this.processData.minMax(data, "ma40", "ma40", minMaxYAxis);
      minMaxYAxis = this.processData.minMax(
        data,
        "bband_u1",
        "bband_l1",
        minMaxYAxis,
      );
      // === set axis
      this[svgField] = chartCanvas.setAxis(
        this[svgField],
        data,
        minMaxYAxis,
        this.dateFormat,
        60,
        8,
      );
    },
    paintChartElements(
      chartCanvas,
      data,
      name,
      showHighlight,
      colorHedge,
      colorExpoAlpha,
      colorExpo,
      colorMA20,
      colorMA40,
      svgField,
    ) {
      // === highlight Patterns
      if (showHighlight === true) {
        chartCanvas.backgroundRect(
          this[svgField],
          data.map((d) => d.date),
          data.map((d) => d.highlight > 0),
          name,
        );
      }
      chartCanvas.linesArea(
        this[svgField],
        this.processData.mapUpperLowerFieldsName(data, "bband_l1", "bband_u1"),
        colorHedge,
        colorHedge,
        1,
        colorExpoAlpha,
      );
      chartCanvas.line(
        this[svgField],
        this.processData.mapFieldName(data, "bband_ma"),
        colorHedge,
        1,
      );
      // === candles
      this[svgField] = chartCanvas.candles(
        this[svgField],
        data,
        colorExpo,
        dnCandles(this.colorTheme),
        name,
        candleAlpha(this.colorTheme),
        candleAlpha(this.colorTheme),
      );
      // === MAs
      chartCanvas.line(
        this[svgField],
        this.processData.mapFieldName(data, "ma20"),
        colorMA20,
        1,
      );
      chartCanvas.line(
        this[svgField],
        this.processData.mapFieldName(data, "ma40"),
        colorMA40,
        1,
      );
      // === text for highlighted Patterns
      if (showHighlight === true) {
        let minY = this[svgField].y.invert(0.999 * this[svgField].height);
        this.idxPatterns.forEach(function(d) {
          d.y = minY;
        });
        chartCanvas.text(
          this[svgField],
          this.idxPatterns,
          "date",
          "y",
          "text",
          name,
          "14px",
          3,
          0,
          "middle",
          "ideographic",
          0,
          textactive(this.colorTheme),
        );

        // === custom hover effects and info on main chart
        this.D3HoverPatterns.hoverFct(
          this[svgField],
          data,
          name,
          this,
          this.dateFormat,
        );
      } else {
        // === custom hover effects and info
        this.D3HoverPatterns.hoverFctPatterns(
          this[svgField],
          data,
          name,
          this.dateFormat,
        );
      }
    },

    callWidth() {
      // Event listener that triggers chart rendering on size change
      this.createSelectedPatternData();

      this.createHistoricalChart(
        this.D3ChartHistorical,
        this.chartData,
        "PATTHIST",
        true,
        "svgNodeHist",
      );

      this.createHistoricalChart(
        this.D3ChartAnalyzed,
        this.processData.toSlice(this.chartData, this.patternLength),
        "PATT1",
        false,
        "svgNodePATT",
      );
      this.createSelectedPatternChart(
        this.D3ChartSelected,
        this.chartDataSelected,
        false,
      );

      setTimeout(() => {
        this.createBarChart();
      }, 1500);
    },
    expandLeftAnimation() {
      if (!this.expandLeft) {
        this.hideRight = true;
        setTimeout(() => {
          this.expandLeft = !this.expandLeft;
        }, 50);
        // for (let i = 0; i < 22; i++) {
        //     setTimeout(() => { this.renderXXXX(); }, (i + 1) * 100);
        // }
      } else {
        this.expandLeft = !this.expandLeft;
        // this.renderLeft += 1;
        setTimeout(() => {
          this.hideRight = false;
        }, 100);
        setTimeout(() => {
          this.renderCandlesMethod();
        }, 200);
      }
    },
    expandRightAnimation() {
      if (!this.expandRight) {
        this.hideLeft = true;
        setTimeout(() => {
          this.expandRight = !this.expandRight;
        }, 50);
        for (let i = 0; i < 22; i++) {
          setTimeout(() => {
            this.renderCandlesMethod();
          }, (i + 1) * 50);
        }
      } else {
        this.expandRight = !this.expandRight;
        this.renderCandlesMethod();
        setTimeout(() => {
          this.hideLeft = false;
        }, 100);
        // setTimeout(() => { this.renderLeft += 1; }, 200);
      }
    },
  },
};
</script>
